/**
* Created by desheng.zhao on 2018/12/3.
*/
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import topTip from "./topTip.vue"
import conFooter from "./footer.vue"


export var global = {
XHeader, XInput, XButton, Group, Cell, Alert, topTip, conFooter
}



export var local = {

}



// WEBPACK FOOTER //
// ./src/components/index.js